import { useCallback, useState } from 'react';
import type { EmailBlock } from '../HtmlEditor.types';

const MAX_HISTORY = 50;

export function useBlockHistory(initialBlocks: EmailBlock[]) {
  const [blocks, setBlocks] = useState<EmailBlock[]>(initialBlocks);
  const [history, setHistory] = useState<EmailBlock[][]>([]);
  const [future, setFuture] = useState<EmailBlock[][]>([]);

  const snapshot = useCallback((next: EmailBlock[]) => {
    setHistory((h) => [...h.slice(-(MAX_HISTORY - 1)), blocks]);
    setFuture([]);
    setBlocks(next);
  }, [blocks]);

  const replaceBlocks = useCallback((next: EmailBlock[], skipHistory = false) => {
    if (skipHistory) {
      setBlocks(next);
      return;
    }
    snapshot(next);
  }, [snapshot]);

  const undo = useCallback(() => {
    if (!history.length) return;
    setFuture((f) => [blocks, ...f]);
    const prev = history[history.length - 1];
    setBlocks(prev);
    setHistory((h) => h.slice(0, -1));
  }, [blocks, history]);

  const redo = useCallback(() => {
    if (!future.length) return;
    setHistory((h) => [...h, blocks]);
    setBlocks(future[0]);
    setFuture((f) => f.slice(1));
  }, [blocks, future]);

  return {
    blocks,
    setBlocks,
    snapshot,
    replaceBlocks,
    undo,
    redo,
    canUndo: history.length > 0,
    canRedo: future.length > 0,
  };
}
